import { connect, FormikValues } from 'formik'
import { cloneDeep, get } from 'lodash'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import Toggle from 'react-toggle'
import styled from 'styled-components'

import { Text } from '@/components/Form'
import { ActionData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'
import { AnyContentBlockTypes } from './NotificationDetail'
import { Label } from './StyledComponents'

export const InputTypes = {
  InputText: 'Input.Text'
}

type InputTextProps = {
  readOnly?: boolean
}

const initialData = {
  type: InputTypes.InputText,
  label: '',
  isRequired: false,
  placeholder: 'Enter text',
  value: ''
}

const StyledRow = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  > div {
    padding-right: 10px;
  }
`

const StyledCentredRow = styled(StyledRow)`
  align-items: center;
  margin: 20px 0;
`

const StyledToggle = styled(Toggle)`
  && {
    padding-right: 0;
    margin-right: 10px;
  }
`

const Component = connect(({ name, formik, readOnly = false }: InputTextProps & FormikValues) => {
  const intl = useIntl()

  useEffect(() => {
    //id will be used to retrieve text input value on event in action feature
    const textInputId = get(formik.values, `${name}.label`, '').replaceAll(/[^A-Za-z]/gm, '')
    formik.setFieldValue(`${name}.id`, textInputId)
    formik.setFieldValue(`${name}.attributeName`, textInputId)
    formik.setFieldValue(`${name}.placeholder`, `Enter ${get(formik.values, `${name}.label`)}`)
    const actionData = formik.values.stepData.notifications[0].actionData
    const newActionData = cloneDeep(actionData) || []
    if (!actionData || !actionData.some((actionDataItem: ActionData) => actionDataItem.id === textInputId)) {
      newActionData.push({
        id: textInputId,
        attributeName: textInputId,
        attributeValue: get(formik.values, `${name}.value`),
        inputType: InputTypes.InputText
      })
    } else {
      const actionDataItemMatch = actionData.find((actionDataItem: ActionData) => actionDataItem.id === textInputId)

      if (
        actionDataItemMatch.attributeName !== get(formik.values, `${name}.label`) ||
        actionDataItemMatch.attributeValue !== get(formik.values, `${name}.value`)
      ) {
        const index = newActionData.findIndex(
          (newActionDataItem: ActionData) => newActionDataItem.id === actionDataItemMatch.id
        )
        if (index !== -1) {
          newActionData[index] = {
            id: textInputId,
            attributeName: textInputId,
            attributeValue: get(formik.values, `${name}.value`),
            inputType: InputTypes.InputText
          }
        }
      }
    }
    formik.setFieldValue(`stepData.notifications[0].actionData`, newActionData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(formik.values, `${name}.label`), name])

  return (
    <div>
      <Text
        disabled={readOnly}
        aria-label={intl.formatMessage(messages.inputLabel)}
        name={`${name}.label`}
        placeholder={intl.formatMessage(messages.inputLabel)}
        maxLength={4000}
        required
        spellCheck
        label={'Label'}
      />
      <StyledCentredRow>
        <Label>{intl.formatMessage(messages.required)}</Label>
        <StyledToggle
          disabled={readOnly}
          aria-label={intl.formatMessage(messages.required)}
          checked={get(formik.values, `${name}.isRequired`)}
          name={`${name}.isRequired`}
          value={String(get(formik.values, `${name}.isRequired`))}
          onChange={() => formik.setFieldValue(`${name}.isRequired`, !get(formik.values, `${name}.isRequired`))}
        />
      </StyledCentredRow>
    </div>
  )
})

const InputText: AnyContentBlockTypes = { Component }

InputText.displayName = InputTypes.InputText

InputText.initialData = { ...initialData }

export default InputText
